export default async function getToolsMenu() {
  return [
    {
      // No url on purpose: this tool opens the copy dialog on the current
      // page (see MenuPagesTools MODAL_ACTIONS) instead of navigating.
      key: 'copyProject',
      icon: 'fe fe-copy',
      permission: 'tools_project_copy',
    },
    {
      key: 'activityLog',
      icon: 'fe fe-activity',
      url: '/activityLog',
      permission: 'activitylog_view',
    },
  ]
}
